export default {
  header: {
    title: 'Cumpără card cadou',
  },
  checkout_btn: {
    title: 'Finalizare comandă',
  },
  items: {
    gift_card: {
      online: 'Card cadou valabil doar online',
      online_and_store: 'Card cadou (valabil online și în magazin)',
      title: 'Selectează suma dorită',
      description: 'Adaugă cardul cadou cu cantitatea dorită în coș',
    },
    expiration: {
      label: 'Valabil 3 ani',
      title: 'Bucură-te de cadou!',
      description: 'Destinatarul poate folosi voucherul flexibil timp de 3 ani.',
    },
    delivery: {
      label: 'Livrare imediată ca PDF prin email',
      title: 'Livrare instantanee ca PDF prin email',
      description: 'După plata securizată vei primi voucherul imediat.',
    },
  },
  form: {
    value: {
      title: 'Alege suma cardului cadou',
      custom: {
        label: 'Personalizat',
        placeholder: 'Introdu suma între {{min}} și {{max}} {{currency}}',
      },
    },
    quantity: {
      title: 'Cantitate',
    },
    email: {
      title: 'Care este adresa ta de email pentru a-ți trimite cardul cadou?',
      placeholder: 'Adresa ta de email',
      error: 'Email invalid',
    },
  },
  confirmation: {
    title: {
      title: 'Cumperi cardul cadou?',
      subtitle_one: 'Dorești să cumperi 1 card cadou pentru {{value}}?',
      subtitle_few: 'Vrei să cumperi {{count}} carduri cadou de {{value}}?',
      subtitle_other: 'Dorești să cumperi {{count}} carduri cadou pentru {{value}}?',
    },
    description: {
      total: 'Total:',
      email: 'E-mail:',
      quantity: 'Cantitate',
      amount: 'Sumă',
    },
    footer: {
      cancel: 'Anulează',
      confirm: 'Confirmă',
    },
  },
};
